// extracted by mini-css-extract-plugin
export default {"root":"Title_root__uihq4","kicker":"Title_kicker__O2XEc","title":"Title_title__r3O3k","wave":"Title_wave__m2+vP"};